<template>
  <div v-loading="loading" class="dsf-control ds-teas-unite-schedule">
    <div v-if="classInfo" class="className">{{ classInfo.name }}</div>
    <dsf-calendar-nav
      :is-design="isDesign"
      :url="url1"
      :data-loaded-fun="dataLoadedFun"
      :to-day="buildToDay"
      @change="scheduleChange"
      isSwitch
      :type="$attrs.type"
    ></dsf-calendar-nav>
    <dsf-virtual-scroll scroll-Y>
      <div v-if="!list.length" class="no-data">没有数据啦~</div>
      <div
        v-for="(item, index) in this.$attrs.dataList"
        :key="index"
        class="dsfa-sc-schedule-list-item"
        :type="item.type"
        @click="toUrl(item)"
      >
        <div class="_sc-s-li_l">
          <div class="_sc-s-li-date">{{ item.stime }}-{{ item.etime }}</div>
          <div class="_sc-s-li-title">
            {{ item.title }}
          </div>
        </div>
        <DsfIcon class="_sc-s-li_icon" name="enter" />
      </div>
    </dsf-virtual-scroll>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfTeasUniteScheduleList",
  mixins: [$mixins.control],
  ctrlCaption: "日程列表",
  design: {
    isMask: false,
  },
  props: {
    url: {
      type: String,
      default: null,
    },
    classInfo: {
      type: Object,
      default: null,
    },
    // 时间
    toDay: {
      type: [String, Date],
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      // 请求次数
      postNum: 0,
      loading: false,
      list: [],
      url2: "",
    };
  },
  computed: {
    buildToDay() {
      let { toDay } = this;
      if (!toDay) {
        return new Date();
      } else {
        return toDay;
      }
    },
    classIdParam() {
      return this.classInfo ? "&classId=" + this.classInfo.id : "";
    },
    url1() {
      if (!this.url || this.url == "") {
        return null;
      }
      return this.url + "?isnum=true" + this.classIdParam;
    },
  },
  created() {
    if (this.isDesign) {
      for (var i = 0; i < 10; i++) {
        this.list.push({
          courseName: "20200118jinhy排课测试课程",
          className: "fuxm外培测试新新新",
          courseTime: "24日14:30-24日17:00",
          teacher: "金皓宇",
          classroom: "知新101",
        });
      }
    }
  },
  mounted() {
    if (this.isDesign) {
      this.$dispatch("design-height-change", "100%");
    }
  },
  methods: {
    reloadData() {
      this.postData();
    },
    dataLoadedFun(data, vm) {
      let _this = this;
      let days = Object.keys(data);
      if (this.postNum > 1) {
        changeActive();
        return;
      }
      let tabCtrl = fn(this.$parent);
      if (!tabCtrl?.slots) {
        return;
      }
      let tabIndex = fnTabIndex(tabCtrl.slots || []);
      let tabName = tabIndex > -1 ? tabCtrl.slots[tabIndex].name : null;
      // 此页无数据
      if (!days.length) {
        // console.log(tabCtrl.active, tabCtrl.slots, tabCtrl, this.caption);
        if (tabIndex > -1) {
          tabCtrl.slots[tabIndex].hasData = false;
          this.$nextTick(() => {
            // 如果恰好此页无数据
            if (tabCtrl.active === tabName) {
              let validTab = tabCtrl.slots.find((s) => s.hasData);
              if (validTab) {
                tabCtrl.tabClick(validTab);
              }
            }
          });
        }
        return;
      }
      changeActive();
      if (tabIndex > -1) {
        tabCtrl.slots[tabIndex].hasData = true;
      }
      // 如果不是此页
      if (tabCtrl.active !== tabName) {
        this.$nextTick(() => {
          let activeTab = tabCtrl.slots.find((s) => s.name === tabCtrl.active);
          if (activeTab.hasData === false) {
            let validTab = tabCtrl.slots.find((s) => s.hasData);
            if (validTab) {
              tabCtrl.tabClick(validTab);
            }
          }
        });
      }

      // 切换到有效的日期去
      function changeActive() {
        // 此页有数据
        if (!data[vm.active.id]) {
          let active = vm.range.find((w) => w.id === days[0]);
          if (active) {
            vm.active = active;
          }
        }
      }
      // 找到tab容器
      function fn(vvm) {
        if (vvm.$parent.ctrlName === "DsfHomeTabPanel") {
          return vvm.$parent;
        }
        if (!vvm.$parent || vvm.$parent === _this.$root) {
          return null;
        }
        return fn(vvm.$parent);
      }
      // 找到所在tab索引
      function fnTabIndex(slots) {
        return slots.findIndex((s) => {
          if (!s.controls) return false;
          return s.controls.find((c) => c.caption === _this.caption);
        });
      }
    },
    scheduleChange({ args: { id } }) {
      if (!this.url || this.url == "") {
        this.url2 = null;
      } else {
        this.url2 =
          this.url +
          "?isnum=false&stime=" +
          id +
          " 00:00:00&etime=" +
          id +
          " 23:59:59" +
          this.classIdParam;
      }
      this.postData();
    },
    postData() {
      if (this.isDesign) return;
      this.postNum++;
      if (!this.url2 || this.url2 == "") {
        this.list = [];
        return;
      }
      this.loading = true;
      this.$http
        .get(this.url2)
        .done(({ success, data, message }) => {
          if (success) {
            let list = Object.values(data);
            this.list = list.length ? list[0] : [];
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.error(err);
          dsf.layer.message(err.message || "请求异常", false);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toUrl({ url, openType }) {
      if (!url) return;
      this.$open({
        url,
        state: openType,
      });
    },
  },
});
</script>
